import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HelpWidgetService {
    readonly hidden = signal(false);
    readonly opened = signal(false);

    show(): void {
        this.hidden.set(false);
        this.opened.set(true);
    }

    dismiss(): void {
        this.opened.set(false);
        this.hidden.set(true);
    }
}
